import { Notification, NotificationBody } from "@adeccoux/tag-ds";
import React from "react";
import { useLocation } from "react-router-dom";
import SesHeader from "../header";
import DisplayButton from "../../util/displaybutton";

const ReadyToStart = ({ setInterstitialShown, handleButtonClick }) => {
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;
    const timed =
        location.state.test.timeLimit != 0 ||
        location.state.test.timedByTopic ||
        location.state.test.timeByQuestion;

    return (
        <>
            <SesHeader clientCobranding={location.state?.cobrandingLink} />
            <div className="flex_col g2 align-items_start xpert-align-self-stretch">
                <div className="flex_col g2 align-items_start xpert-align-self-stretch justify-content_center text-01">
                    <span style={{ fontSize: "40px" }} className="material-icons-outlined" >
                        sentiment_satisfied_alt
                    </span>
                    <h3>{phrases?.["26000066"]}</h3>
                </div>
                {timed && (
                    <Notification
                        className="docs"
                        data-testid="notification"
                        icon={<span className="material-icons-outlined">info</span>}
                        show
                        info
                    >
                        <NotificationBody className="tost_message">
                            {phrases?.["26000065"]}
                        </NotificationBody>
                    </Notification>
                )}
            </div>
            <DisplayButton
                buttons={[location.state.test?.status?.id === 4 ? (<span></span>) : (
                    <button type="button" className="button-secondary text_uppercase" onClick={() => { setInterstitialShown(false); }}>
                        {phrases?.["1000229"]}
                    </button>
                ), <button type="button" className="text_uppercase full-width_mobile" onClick={() => handleButtonClick(false)} >
                    {location.state.test?.status?.id === 4 ? phrases?.["1001241"] : phrases?.["11070"]}
                </button>
                ]} />
        </>
    );
};
export default ReadyToStart;
